import { SharedColumnSettingsService } from './../../../modules/shared/services/column-settings.service';
import { AccountModuleId } from './../../../modules/shared/constants/modules.constant';
import { ColumnSettingsN } from './../../../modules/shared/models/column-settings.model';
import { PhoneNumberFormatService } from './../../../modules/shared/services/phone-number-format.service';
import { ParseHelper } from './../../../modules/shared/parse.helper';
import { ContactService } from '../../../contacts/contactService';
import { CONTACT_ASSOCIATION_ID } from '../../../modules/shared/constants/typeId';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  AbstractControl,
  AsyncValidatorFn,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { Observable, of, Subject } from 'rxjs';
import { catchError, map, takeUntil, tap } from 'rxjs/operators';

// Components
import { AppMainComponent } from 'src/app/app.main.component';

// PrimeNg and Packages
import {
  ConfirmationService,
  ConfirmEventType,
  MessageService,
} from 'primeng/api';

// Models and States
import { Account } from 'src/app/accounts/model/account';
import {
  AccountAdd,
  Address,
  ContactEmail,
  ContactPhone,
  ContactSocialProfile,
  CustomAttributeValue,
} from '../../models/accountAdd.model';
import { AccountSource } from '../../models/fields/accountSource.model';
import { AccountType } from '../../models/fields/accountType.model';
import { AccountWithName } from '../../models/accountWithName';
import { AddressClass } from '../../models/fields/addressClass.model';
import { AddressType } from '../../models/fields/addressType.model';
import { AnnualRevenue } from '../../../modules/shared/model/annualRevenue.model';
import { Channel } from '../../models/configuration/channel.model';
import { Country } from '../../models/fields/country.model';
import { Currency } from '../../../modules/shared/model/currency.model';
import { EmployeeCount } from '../../../modules/shared/model/employeeCount.model';
import { Industry } from '../../../modules/shared/model/industry.model';
import { JobFunction } from 'src/app/contacts/model/jobFunction.model';
import { Language } from '../../models/fields/language.model';
import { Ownership } from '../../../modules/shared/model/ownership.model';
import { Rating } from '../../../modules/shared/model/rating.model';
import { Salutation } from 'src/app/contacts/model/salutation.model';
import { Stage } from '../../models/configuration/stage.model';
import { TemplateSection } from 'src/app/modules/shared/model/templateSection.model';
import { Timezone } from '../../../modules/shared/model/timezone.model';

// Pipes
import { PhoneValidationPipe } from 'src/app/modules/shared/pipes/phone-validation-message.pipe';

// Services
import { AccountHelper } from '../../services/accounts.helper';
import { AccountLeadDataService } from 'src/app/modules/shared/stores/accountLeadDataStore/accountLeadData.service';
import { AccountsHttpService } from 'src/app/modules/shared/services/accounts.http.service';
import { AccountServiceN } from '../../services/account.services';
import { AppMainService } from 'src/app/app-main.service';
import { SharedCRMConfigService } from 'src/app/configurations/crm/shared/services/shared-crm-config.service';
import { SharedDataService } from 'src/app/modules/shared/stores/sharedDataStore/sharedData.service';
import { FileService } from 'src/app/modules/shared/services/file.service';

// Constants and Enums
import { Status } from '../../accounts.enum';
import {
  EmailFields,
  EmailFieldsMain,
  PhoneFields,
  Sections,
} from '../../accounts.constant';
import {
  EMAIL_TYPE_IDS,
  PHONE_TYPE_IDS,
  SOCIAL_PROFILE_TYPE_IDS,
} from 'src/app/modules/shared/constants/typeId';
import { ObjectNames } from 'src/app/shared/constants';

// Shared and Helpers
import { uploadFiles, validateFiles } from 'src/app/shared/upload-files';
import { getCustomFormControlFields } from 'src/app/modules/shared/helpers/generate-form.helper';

// JSON
import { TemplateSectionFields } from './templateSectionFields.js';
import { UserAccess } from '../accounts-details/models/userAccess';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { StoreService } from 'src/app/modules/shared/services/store.service';
import { CustomAttributeService } from 'src/app/modules/shared/services/custom-attribute.service';
import { Tag } from '../../models/tag.model';
import { CrmSettingModel } from 'src/app/configurations/models/organization-settings.model';
import { CrmSettingsService } from 'src/app/modules/shared/services/crm-settings.service';
import { AccountUserService } from 'src/app/service/account.service';
import { ImportserialService } from 'src/app/modules/shared/services/importserial.service';

@Component({
  selector: 'app-add-view-account',
  templateUrl: './add-view-account.component.html',
  styleUrls: ['./add-view-account.component.scss'],
})
export class AddViewAccountComponent implements OnInit, OnChanges {
  @Input() displayAddView: boolean=false
  @Input() isAdd: boolean;
  @Input() isEdit: boolean;
  @Input() objectId: number;
  @Input() editPermission: boolean;
  @Input() selectedChannel: Channel;
  @Input() selectedAccount: Account;
  @Input() stages: Stage[] = [];
  @Input() selectedStage: Stage;
  //new Input property for SequenceNumber
  @Input() isSequenceNumberFeild: boolean;
  @Input() generateSequenceSeriesNumber: string;
  accountSequenceNumberServiceResponse: any;
  @Input() currentSelectedAccountChannelIdForCopy: any;
  @Input() businessClassificationForCopy: any = {};
  data: any;
  @Output() completeAccountAdd = new EventEmitter();
  @Output() completeAccountEdit = new EventEmitter();
  @Output() switchToEdit = new EventEmitter();
  @Output() closeModal = new EventEmitter();

  isShowMore: boolean = false;
  addressList: any[] = [];
  countryData: any;

  // Template
  accountModuleId = AccountModuleId;
  templateSections: TemplateSection[] = [];
  customSections: TemplateSection[] = [];
  checkedFields: any = {};
  isTemplateLoading: boolean = false;
  noTemplateMessage: string = '';
  isChildTemplate:boolean=false

  // Add, Edit, View
  formSubmitted: boolean = false;
  accountForm: FormGroup;
  accountInfoCustomForm: FormGroup;
  accountDetailsCustomForm: FormGroup;
  customAttributeValues: CustomAttributeValue[] = [];
  selectedParentAccount: any;
  parentAccounts: AccountWithName[] = [];
  accountExistMsg: string = '';
  statusEnum = Status;
  selectedProfileImages = [];
  shownProfileImages = [];
  tabIndex: number = 0;
  allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif'];
  viewAccountData = {};
  showAccountInfoMore: boolean = false;
  isSubmitted: boolean = false;
  isChildFormTouched: boolean = false;
  phoneNumberFormat: string = null;

  //custom Attribute
  accountInfoCustomField = [];
  accountInfoCustomValue = [];
  accountDetailsCustomField = [];
  accountDetailsCustomValue = [];

  accountTempAddress: any[] = [];

  // Contact Emails, Phones, Social Profiles payload array
  contactEmails: ContactEmail[] = [
    {
      emailTypeId: EMAIL_TYPE_IDS.WORK,
      emailAddress: '',
    },
    {
      emailTypeId: EMAIL_TYPE_IDS.HOME,
      emailAddress: '',
    },
    {
      emailTypeId: EMAIL_TYPE_IDS.CE1,
      emailAddress: '',
    },
    {
      emailTypeId: EMAIL_TYPE_IDS.CE2,
      emailAddress: '',
    },
  ];
  contactPhones: ContactPhone[] = [
    {
      formControlName: 'contactWorkPhone',
      phoneTypeId: PHONE_TYPE_IDS.WORK,
      phoneNumber: '',
      code: null,
      country: null
    },
    {
      formControlName: 'contactHomePhone',
      phoneTypeId: PHONE_TYPE_IDS.HOME,
      phoneNumber: '',
      code: null,
      country: null
    },
    {
      formControlName: 'contactMobilePhone',
      phoneTypeId: PHONE_TYPE_IDS.MOBILE,
      phoneNumber: '',
      code: null,
      country: null
    },
    {
      formControlName: 'contactCP1Phone',
      phoneTypeId: PHONE_TYPE_IDS.CP1,
      phoneNumber: '',
      code: null,
      country: null
    },
    {
      formControlName: 'contactCP2Phone',
      phoneTypeId: PHONE_TYPE_IDS.CP2,
      phoneNumber: '',
      code: null,
      country: null
    },
  ];
  accountPhoneMaskingDisabled: boolean = false;

  contactSocialProfiles: ContactSocialProfile[] = [
    {
      socialProfileTypeId: SOCIAL_PROFILE_TYPE_IDS.TWITTER,
      socialProfileAddress: '',
    },
    {
      socialProfileTypeId: SOCIAL_PROFILE_TYPE_IDS.FACEBOOK,
      socialProfileAddress: '',
    },
    {
      socialProfileTypeId: SOCIAL_PROFILE_TYPE_IDS.LINKEDIN,
      socialProfileAddress: '',
    },
    {
      socialProfileTypeId: SOCIAL_PROFILE_TYPE_IDS.INSTAGRAM,
      socialProfileAddress: '',
    },
    {
      socialProfileTypeId: SOCIAL_PROFILE_TYPE_IDS.WEBSITE,
      socialProfileAddress: '',
    },
  ];

  // Subject to unsubscribe
  private ngUnsubscribe = new Subject<void>();

  // Dropdown Values to populate on form
  activeUsers = [];
  salutations: Salutation[] = [];
  jobFunctions: JobFunction[] = [];
  accountTypes: AccountType[] = [];
  accountSources: AccountSource[] = [];
  employeeCount: EmployeeCount[] = [];
  timezones: Timezone[] = [];
  currencies: any[] = [];
  ratings: Rating[] = [];
  revenues: AnnualRevenue[] = [];
  ownerships: Ownership[] = [];
  industries: Industry[] = [];
  countries: Country[] = [];
  languages: Language[] = [];
  addressTypes: AddressType[] = [];
  addressClasses: AddressClass[] = [];
  contactRoles: any[] = [];

  // Default Values
  defaultSalutation: Salutation;
  defaultJobFunction: JobFunction = null;
  defaultContactRoles : any[] = [];
  defaultAccountTypes: AccountType[] = [];
  defaultAccountSource: AccountSource;
  defaultEmployeeCount: EmployeeCount;
  defaultCurrency: Currency;
  defaultRating: Rating;
  defaultRevenue: AnnualRevenue;
  defaultOwnership: Ownership;
  defaultIndustry: Industry;
  defaultAddressType: AddressType;
  defaultAddressClass: AddressClass;
  dataForCopy: any;

  // User Access
  userAccessByTerritoryList: UserAccess[] = [];

  @Input() isCopyAccount: boolean = false;
  tags: Tag[] = [];
  isEditTag = false;
  displayAddTag = false;

  //communication
  communication = [
    { id: 1, name: 'SMS', isSubscrib: true, unSubscrib: false },
    { id: 2, name: 'WhatsApp', isSubscrib: true, unSubscrib: false },
    { id: 3, name: 'Work Email', isSubscrib: true, unSubscrib: false },
    { id: 4, name: 'Home Email', isSubscrib: true, unSubscrib: false },
    { id: 4, name: 'Work Phone', isSubscrib: false, unSubscrib: true },
    { id: 5, name: 'Mobile Phone', isSubscrib: false, unSubscrib: true },
  ];
  //tags
  tagList: Tag[] = [];
  selectedValues: any[] = [];
  pageSize: number = 5;
  filterDropdownList: { name: string; id: number }[] = [
    { name: 'Assigned', id: 1 },
    { name: 'UnAssigned', id: 2 },
    { name: 'All', id: 3 },
  ];
  first: number = 0;
  displayCreateTag: boolean = false;

  /** Custom Section */
  customSectionsForm: FormGroup[] = [];
  accountOwnerSettings: any = {};
  selectedOwnerStageDefault: any = {};
  selectedOwnerStage: any = {};

  //Parent Account Selection
  displayManualPopup: boolean = false;
  manualRuleColumnSetttings: Partial<ColumnSettingsN> = {};
  selectedRecordList: any[] = [];
  selectedModule = {id: AccountModuleId, name: 'Account'};

  constructor(
    private formBuilder: FormBuilder,
    private app: AppMainComponent,
    private accountService: AccountServiceN,
    private accountsHttpService: AccountsHttpService,
    private sharedConfigService: SharedCRMConfigService,
    private messageService: MessageService,
    private appMainService: AppMainService,
    private accountDataService: AccountLeadDataService,
    private sharedDataService: SharedDataService,
    private accountHelper: AccountHelper,
    private phoneValidationPipe: PhoneValidationPipe,
    private fileService: FileService,
    private storeService: StoreService,
    private configurationService: ConfigurationService,
    private customAttributeService: CustomAttributeService,
    private confirmationService: ConfirmationService,
    private contactService: ContactService,
    private crmSettingsService: CrmSettingsService,
    private accountUserService: AccountUserService,
    private phoneNumberFormatService: PhoneNumberFormatService,
    private columnSettingsService: SharedColumnSettingsService,
    private importService: ImportserialService,
  ) {}

  ngOnInit() {
    this.getNewAccountData()
    this.getCountryCode();
    this.getPhoneNumberTemplate();
  }

  getNewAccountData(){
    this.dataForCopy =  ParseHelper.DeepCopy(this.storeService.getAccountData().value);
    this.contactPhones.map(phone=>{
        phone.country = this.app.userDetails?.locations?.[0]?.address?.country?.name || this.app.organizationData?.address?.country?.name;
        phone.code = this.app.userDetails?.locations?.[0]?.address?.country?.phoneCode || this.app.organizationData?.address?.country?.phoneCode;
    });

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.displayAddView?.currentValue) {
      this.tabIndex = 0;
      if (!changes?.isAdd?.currentValue && !changes?.isEdit?.currentValue) {
        //this.getUserAccessByTerritory();
      }
    }

    if (changes?.isAdd?.currentValue || changes?.isCopyAccount?.currentValue) {
      this.accountForm?.enable();
    }

    if (changes?.currentSelectedAccountChannelIdForCopy?.currentValue) {
      this.currentSelectedAccountChannelIdForCopy =
        changes.currentSelectedAccountChannelIdForCopy.currentValue;
      this.getTemplateFormFields(this.currentSelectedAccountChannelIdForCopy);
    }

    if (changes.selectedChannel?.currentValue) {
      if (this.isCopyAccount === false) {
        this.accountForm?.patchValue({ channelId: this.selectedChannel.id });
        this.getTemplateFormFields(this.selectedChannel.id);
      }
    }

    if (!this.isAdd && !this.isEdit) {
      this.prepareAccountViewUI();
    }

    if (changes?.stages?.currentValue) {
      this.stages = changes.stages.currentValue?.filter((el) => el.id);
    }

    if (!this.selectedStage?.id && this.stages.length) {
      this.selectedStage = this.stages[0];
    }

    if (changes.isSequenceNumberFeild?.currentValue) {
      this.isSequenceNumberFeild = changes.isSequenceNumberFeild.currentValue;
    }

    if (changes.businessClassificationForCopy?.currentValue) {
      this.businessClassificationForCopy =
        changes.businessClassificationForCopy.currentValue;
    }
  }

  prepareAccountViewUI(): void {
    this.viewAccountData = this.accountHelper.processViewData(
      this.selectedAccount
    );
    this.app.objectId = this.selectedAccount?.id;
    this.app.objectType = ObjectNames.ACCOUNT;
  }

  getUserAccessByTerritory(): void {
    this.appMainService.isShowSpinner('getUserAccessByTerritory');
    this.accountService
      .getUserAccess(this.selectedAccount?.id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response) => {
          this.userAccessByTerritoryList = response.filter(
            (x) => x.ownerType == 'Primary Owner'
          );
        },
        error: () => {
          this.appMainService.isHideSpinner('getUserAccessByTerritory');
        },
        complete: () => {
          this.isTemplateLoading = false;
          this.displayAddView = true;
          this.appMainService.isHideSpinner('getUserAccessByTerritory');
        },
      });
  }

  prepareAccountFormDataForCopy() {
    this.accountTempAddress = [];
    if(this.dataForCopy?.tags?.length > 0){
      this.tags = this.dataForCopy?.tags;
    }
    this.dataForCopy?.accountAddresses.map((address) => {
      address.accountId = 0;
      address.addressId = 0;

      if (address.address) {
        address.address.attnContactId = 0;
        address.address.attnContact = null;
      }
      this.accountTempAddress.push(address);
    });

    if (this.accountTempAddress?.length > 0) {
      this.onUpdateAddressList({ addressList: this.accountTempAddress });
    }

    const allContactPhones = this.dataForCopy.accountContacts.find(contact=> contact?.isPrimaryContact)?.contact?.contactPhones||[];
    this.contactPhones.map((contactPhones) => {
        const phone = allContactPhones.find(contact=> contactPhones.phoneTypeId === contact.phone?.phoneTypeId)
        if (phone) {
          contactPhones.phoneNumber = phone.phone?.number;
          contactPhones.code = phone.phone?.code;
          contactPhones.country = phone.phone?.country;
          contactPhones.maskingDisabled = this.phoneNumberFormatService.checkMaskingDisabled(contactPhones.phoneNumber);
        }
    });

    const defaultCountry = this.app.userDetails?.locations?.[0]?.address?.country?.name||this.app.organizationData?.address?.country?.name;
    const defaultCode = this.app.userDetails?.locations?.[0]?.address?.country?.phoneCode||this.app.organizationData?.address?.country?.phoneCode;
    this.accountPhoneMaskingDisabled = this.phoneNumberFormatService.checkMaskingDisabled(this.dataForCopy?.workphone);
    this.accountForm?.patchValue({
      channelId: this.currentSelectedAccountChannelIdForCopy,
      accountName: this.dataForCopy?.businessName,
      contactFirstName: this.dataForCopy?.contactFirstName,
      contactMiddleName: this.dataForCopy?.contactMiddleName,
      contactLastName: this.dataForCopy?.contactLastName,
      contactWorkEmail: this.dataForCopy?.contactemailwork,
      contactHomeEmail: this.dataForCopy?.contactemailhome,
      contactCE1Email: this.dataForCopy?.contactemailce1,
      contactCE2Email: this.dataForCopy?.contactemailce2,
      contactWorkPhone: this.dataForCopy?.contactphonework||null,
      contactHomePhone: this.dataForCopy?.contactphonehome||null,
      contactMobilePhone: this.dataForCopy?.contactphonemobile||null,
      contactCP1Phone: this.dataForCopy?.contactphonecp1||null,
      contactCP2Phone: this.dataForCopy?.contactphonecp2||null,
      contactSocialTwitter: this.dataForCopy?.contactsocialtwitter,
      contactSocialFacebook: this.dataForCopy?.contactsocialfacebook,
      contactSocialLinkedIn: this.dataForCopy?.contactsociallinkedin,
      contactSocialInstagram: this.dataForCopy?.contactsocialinstagram,
      contactSocialWebsite: this.dataForCopy?.contactsocialwebsite,
      foundedYear: this.dataForCopy?.foundedYear,
      accountNumber: this.dataForCopy?.accountNumber,
      doingBusinessAs: this.dataForCopy?.doingBusinessAs,
      taxId: this.dataForCopy?.taxId,
      sicCode: this.dataForCopy?.sicCode,
      naicsCode: this.dataForCopy?.naicsCode,
      accountSocialWebsite: this.dataForCopy?.website,
      accountSocialTwitter: this.dataForCopy?.twitter,
      accountSocialFacebook: this.dataForCopy?.facebook,
      accountSocialLinkedIn: this.dataForCopy?.linkedin,
      accountSocialInstagram: this.dataForCopy?.instagram,
      accountEmail: this.dataForCopy?.work,
      accountPhone: this.dataForCopy?.workphone||null,
      accountPhoneCountry: this.dataForCopy?.workphoneCountry||defaultCountry,
      accountPhoneCode: this.dataForCopy?.workphoneCode||defaultCode,
      notes: this.dataForCopy?.description,
      shownProfileImages:
        this.dataForCopy.accountContacts?.[0]?.contact?.contactProfileImages,
    });
  }

  getTemplateFormFields(channelId: number): void {
    // this.displayAddView = false;
    this.isTemplateLoading = true;
    this.appMainService.isShowSpinner('getTemplateFormFields');
    this.sharedConfigService
      .getTemplateFormFields(this.accountModuleId, channelId,this.isChildTemplate)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response) => {
          this.templateSections = response || [];
          this.customSections = response && response.length > 0 ? response.filter(section => section.systemGenerated == false) : [];
          this.customSections = this.customSections.filter(section=> section && section.customFields && section.customFields.length > 0);
          this.prepareFormFieldsWithData();
          this.noTemplateMessage = '';
        },
        error: () => {
          this.templateSections = [];
          this.customSections = [];
          this.noTemplateMessage = 'Error loading template under this channel.';
        },
        complete: () => {
          this.isTemplateLoading = false;
          this.displayAddView = true;
          this.appMainService.isHideSpinner('getTemplateFormFields');
        },
      });
  }

  prepareFormFieldsWithData(): void {
    this.prepareAccountForm();
    this.generateSequenceNumber();
    this.prepareAccountInfoCustomForm();
    this.prepareAccountDetailsCustomForm();
    this.prepareCustomSectionForm();
    this.getDropdownValues();
    this.loadTages();
    this.getSettingsData();
    !this.accountTypes?.length &&
      this.accountDataService.dispatchGettingAllStores();
    !this.salutations?.length &&
      this.sharedDataService.dispatchGettingAllStores();
  }

  generateSequenceNumber() {
    this.configurationService
      .generateSequenceNumberByModuleId(AccountModuleId)
      .subscribe((response) => {
        this.generateSequenceSeriesNumber = response;
        this.accountForm
          .get('sequenceNumber')
          .setValue(this.generateSequenceSeriesNumber);
      });
  }

  generateChildSequenceNumber(parentId: number) {
    this.configurationService
      .generateChildAccountSequenceNumber(parentId)
      .subscribe((response) => {
        this.generateSequenceSeriesNumber = response;
        this.accountForm
          .get('sequenceNumber')
          .setValue(this.generateSequenceSeriesNumber);
      });
  }

  // Prepare the whole new account form
  prepareAccountForm(data?): void {
    const formGroupFields = this.getFormControlFields(data);
    this.accountForm = this.formBuilder.group(formGroupFields);

    const defaultCountry = this.app.userDetails?.locations?.[0]?.address?.country?.name||this.app.organizationData?.address?.country?.name;
    const defaultCode = this.app.userDetails?.locations?.[0]?.address?.country?.phoneCode||this.app.organizationData?.address?.country?.phoneCode;

    this.accountForm.patchValue({
        accountPhoneCountry: defaultCountry,
        accountPhoneCode: defaultCode
    });

    this.accountForm.get('sequenceNumber')?.disable();

    if (!this.isEdit && !this.isAdd) {
      this.accountForm?.disable();
    }
    if (this.isCopyAccount) {
      this.accountForm?.enable();
      this.prepareAccountFormDataForCopy();
    }
  }

  // Get all the form controls fields
  getFormControlFields(data?): any {
    // this.checkedFields={};
    let formGroupFields = {
      channelId: data?.channelId || this.selectedChannel.id,
    };

    // Generate the form by taking the form control names from the JSON data
    for (const fields of TemplateSectionFields) {
      for (const fieldData of fields) {
        if (fieldData.childFields.length) {
          for (const childFieldData of fieldData.childFields) {
            const validators = this.getValidators(childFieldData);
            const asyncValidators = this.getAsyncValidators(childFieldData);

            formGroupFields[childFieldData?.field] =
              validators.length || asyncValidators.length
                ? new FormControl(null, {
                    validators: validators,
                    asyncValidators: asyncValidators,
                    updateOn: asyncValidators.length > 0 ? 'blur' : 'change',
                  })
                : new FormControl(null);
          }
        } else {
          const validators = this.getValidators(fieldData);
          const asyncValidators = this.getAsyncValidators(fieldData);

          formGroupFields[fieldData.field] =
            validators.length || asyncValidators.length
              ? new FormControl(null, {
                  validators: validators,
                  asyncValidators: asyncValidators,
                  updateOn: asyncValidators.length > 0 ? 'blur' : 'change',
                })
              : new FormControl(null);
        }
      }
    }

    // Generate the checkedFields object to show/hide form control fields in the form
    for (const { name, fields } of this.templateSections) {
      for (const fieldData of fields) {
        if (fieldData.name) {
          if (fieldData.childFields?.length) {
            fieldData.name = this.accountHelper.processFieldName(
              fieldData.name
            );

            this.checkedFields[fieldData.name] = {
              labelName: fieldData.labelName,
            };

            for (const childFieldData of fieldData.childFields) {
              childFieldData.name = this.accountHelper.processFieldName(
                childFieldData.name
              );

              if (
                name === Sections.CONTACT_DETAILS &&
                fieldData.name === 'SocialProfile'
              ) {
                childFieldData.name = 'Contact' + childFieldData.name;
              } else if (
                name === Sections.ACCOUNT_DETAILS &&
                fieldData.name === 'AccountSocial'
              ) {
                childFieldData.name = 'Account' + childFieldData.name;
              }

              this.checkedFields[childFieldData.name] = {
                labelName: childFieldData.labelName,
              };
            }
          } else {
            fieldData.name = this.accountHelper.processFieldName(
              fieldData.name
            );

            if (
              fieldData.name == 'AccountEmail' ||
              fieldData.name == 'AccountPhone'
            ) {
              continue;
            }

            this.checkedFields[fieldData.name] = {
              labelName: fieldData.labelName,
            };
          }
        }
      }
    }
    formGroupFields['stageOwnerId'] = new FormControl(null);
    return formGroupFields;
  }

  // Get validators
  getValidators(fieldData: any): any[] {
    const validators = [];

    if (fieldData.isRequired) {
      validators.push(Validators.required);
    }

    if (fieldData.maxLength) {
      validators.push(Validators.maxLength(fieldData.maxLength));
    }

    if (EmailFields.includes(fieldData.field)) {
      // validators.push(Validators.pattern("[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"));
    }

    if (PhoneFields.includes(fieldData.field)) {
      // validators.push(Validators.pattern("^[0-9()\ +-]+$"));
    }

    return validators;
  }

  getAsyncValidators(fieldData: any): any[] {
    const validators: any[] = [];
    if (EmailFieldsMain.includes(fieldData.field)) {
      validators.push(this.emailExistValidator(fieldData.field));
    }
    return validators;
  }

  emailExistValidator(controlName: string): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      const emailAddress: string = control.value?.trim();
      const accountEmail = this.accountForm?.value?.accountEmail;
      const workEmail = this.accountForm?.value?.contactWorkEmail;

      if (this.accountForm && controlName == 'accountEmail') {
        const wEctl = this.accountForm.controls['contactWorkEmail'];
        const hEctl = this.accountForm.controls['contactHomeEmail'];

        if (wEctl) wEctl.updateValueAndValidity();
        if (hEctl) hEctl.updateValueAndValidity();
      }

      if (this.accountForm && controlName == 'contactWorkEmail') {
        const hEctl = this.accountForm.controls['contactHomeEmail'];
        if (hEctl) hEctl.updateValueAndValidity();
      }

      if (
        !emailAddress ||
        (['contactWorkEmail', 'contactHomeEmail'].includes(controlName) &&
          accountEmail) ||
        (['contactHomeEmail'].includes(controlName) && workEmail)
      )
        return of(null);

      return this.accountService.accountEmailValidation(emailAddress).pipe(
        map((res) => {
          return res ? null : { emailExists: true };
        }),
        catchError(() => of(null))
      );
    };
  }

  contactEmailCheck(
    emailAddress: string,
    formControlName: string,
    index: number
  ) {
    setTimeout(() => {
      if (
        this.isInvalid(formControlName) ||
        !emailAddress ||
        !this.displayAddView ||
        this.formSubmitted
      )
        return;

      this.contactService
        .contactEmailValidation(emailAddress, CONTACT_ASSOCIATION_ID.ACCOUNT)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (response) => {
            if (!response) {
              this.confirmationService.confirm({
                message: `${emailAddress} email already used in a contact, do you want to use it again?`,
                header: 'Email Already Used',
                icon: 'pi pi-exclamation-triangle',
                rejectLabel: 'Clear',
                acceptLabel: 'Yes',
                accept: () => {},
                reject: (type) => {
                  if (type == ConfirmEventType.REJECT) {
                    this.accountForm?.get(formControlName).patchValue('');
                    this.contactEmails[index].emailAddress = '';
                  }
                },
              });
            }
          },
          error: (error) => {},
        });
    }, 400);
  }

  // Check field validations and operations
  isTouchedInvaild(formControlName: string): boolean {
    return (
      (this.accountForm?.get(formControlName)?.invalid &&
        this.accountForm?.get(formControlName)?.touched) ||
      this.isSubmitted
    );
  }

  isTouched(formControlName: string): boolean {
    return this.accountForm?.get(formControlName)?.touched;
  }

  hasValue(formControlName: string): boolean {
    return this.accountForm?.get(formControlName)?.value;
  }

  isInvalid(formControlName: string): boolean {
    return !!this.accountForm?.get(formControlName)?.invalid;
  }

  hasRequiredError(formControlName: string): boolean {
    return this.accountForm?.get(formControlName)?.hasError('required');
  }

  hasLengthError(formControlName: string): boolean {
    return !this.accountForm?.get(formControlName)?.value?.trim()?.length;
  }

  hasMaxLengthError(formControlName: string): boolean {
    return this.accountForm?.get(formControlName)?.hasError('maxlength');
  }

  hasEmailExistError(formControlName: string): boolean {
    return this.accountForm?.get(formControlName)?.hasError('emailExists');
  }

  hasMaxPhoneLengthError(formControlName: string): boolean {
    const phoneValue: string = this.accountForm?.get(formControlName)?.value;
    return this.phoneValidationPipe.transform(phoneValue);
  }

  hasPatternError(formControlName: string): boolean {
    return this.accountForm?.get(formControlName)?.hasError('pattern');
  }

  // Set values of custom attributes with respective ID
  setCustomFieldValue({ customFieldId, customFieldData, type }): void {
    const accountInfoCustomFields = this.templateSections[1].customFields;
    const foundInfoField = accountInfoCustomFields.find(
      (field) => field.customAttributeId === customFieldId
    );

    if (foundInfoField) {
      const data: any = {
        id: foundInfoField.customAttributeId,
      };

      if (type === 'attachments') {
        data.attachments = customFieldData;
      } else {
        data.values = this.accountHelper.formatCustomFieldData(customFieldData, foundInfoField);
      }

      this.updateCustomFieldsListing(foundInfoField.customAttributeId, data);
    } else {
      const accountDetailsCustomFields = this.templateSections[2].customFields;
      const foundDetailsField = accountDetailsCustomFields.find(
        (field) => field.customAttributeId === customFieldId
      );

      if (foundDetailsField) {
        const data: any = {
          id: foundDetailsField.customAttributeId,
        };

        if (type === 'attachments') {
          data.attachments = customFieldData;
        } else {
          data.values = this.accountHelper.formatCustomFieldData(customFieldData, foundDetailsField);
        }

        this.updateCustomFieldsListing(
          foundDetailsField.customAttributeId,
          data
        );
      }
    }
  }

  // Update custom fields listing
  updateCustomFieldsListing(id: number, data: any): void {
    const foundIndex = this.customAttributeValues.findIndex(
      (attribute) => attribute.id == id
    );

    if (foundIndex > -1) {
      this.customAttributeValues[foundIndex] = data;
    } else {
      this.customAttributeValues.push(data);
    }
  }

  generateAcccountInfoCustomFields() {
    const customAttributeValue = this.dataForCopy?.customAttributeValues || [];
    const sectionCustomField = this.templateSections[1]?.customFields || [];
    const data = this.customAttributeService.generateCustomFieldValues(
      'Account',
      'Information',
      customAttributeValue,
      sectionCustomField
    );
    this.accountInfoCustomField = data.customFields;
    this.accountInfoCustomValue = data.customValues;
  }

  generateAcccountDetailsCustomFields() {
    const customAttributeValues =
      this.selectedAccount?.customAttributeValues || [];
    const sectionCustomFields = this.templateSections[2]?.customFields || [];
    const data = this.customAttributeService.generateCustomFieldValues(
      'Account',
      'Details',
      customAttributeValues,
      sectionCustomFields
    );
    this.accountDetailsCustomField = data.customFields;
    this.accountDetailsCustomValue = data.customValues;
  }

  // Prepare account information custom form
  prepareAccountInfoCustomForm(): void {
    const customFormControlFields = getCustomFormControlFields(
      this.templateSections[1].customFields
    );
    this.accountInfoCustomForm = new FormGroup(customFormControlFields);
  }

  // Prepare account details custom form
  prepareAccountDetailsCustomForm(): void {
    const customFormControlFields = getCustomFormControlFields(
      this.templateSections[2].customFields
    );
    this.accountDetailsCustomForm = new FormGroup(customFormControlFields);
  }

  /** Custom Section */

  /** prepare Custom Section form */
  prepareCustomSectionForm() {
    this.customSectionsForm = this.customSections?.map(section =>
      section && section.customFields && section.customFields.length > 0
        ? this.createCustomSectionForm(section.customFields)
        : null
    );
  }
  private createCustomSectionForm(customFields: any[]): FormGroup {
    const customFormControlFields = getCustomFormControlFields(customFields);
    return new FormGroup(customFormControlFields);
  }

  /** set Custom Section field value */
  setCustomSectionFieldValue({ customFieldId, customFieldData, type, sectionId }){
    const section = this.customSections.find(s => s.id == sectionId);
    const foundInfoField = section.customFields.find((field) => field.customAttributeId === customFieldId);

    if (foundInfoField) {
      const data: any = { id: foundInfoField.customAttributeId};
      if (type === 'attachments') {
        data.attachments = customFieldData;
      } else {
        data.values = this.accountHelper.formatCustomFieldData(customFieldData, foundInfoField);
      }
      this.updateCustomFieldsListing(foundInfoField.customAttributeId, data);
    }
  }

  /** End Custom Section */

  // Populate all the dropdown data from NgRx Store
  getDropdownValues(): void {
    this.loadUsers();
    this.loadSalutations();
    this.loadJobFunctions();
    this.loadAccountTypes();
    this.loadAccountSources();
    this.loadEmployeeCount();
    this.loadTimezones();
    this.loadCurrencies();
    this.loadRatings();
    this.loadAnnualRevenues();
    this.loadOwnerships();
    this.loadIndustries();
    this.loadCountries();
    this.loadLanguages();
    this.loadAddressTypes();
    this.loadAddressClasses();
    this.populateDefaultBusinessClassification();
    this.loadContactRoles();
  }

  formatDropDownData(data: any[]): any[] {
    return (
      data
        ?.filter((el) => el.isActive)
        ?.map((el) => {
          return { id: el.id, name: el.name };
        }) || []
    );
  }

  formatDropDownDataJobFunction(data: any[]): any[] {
    return (
      data
        ?.filter((el) => el.isActive)
        ?.map((el) => {
          return { id: el.id, name: el.name , isDefault: el?.isDefault};
        }) || []
    );
  }

  getDefaultData(data: any[], multiple: boolean = false): any {
    const filteredData: any[] = data
      ?.filter((el) => el.isDefault)
      ?.map((el) => {
        return { id: el.id, name: el.name };
      });
    return filteredData ? (multiple ? filteredData : filteredData[0]) : null;
  }

  /* Users: load data and populate default value */
  loadUsers(): void {
    this.activeUsers = this.app.usersList.filter((obj) => obj.statusId == 1);
    const loggedInUserId =
      JSON.parse(localStorage.getItem('user'))?.userId || 0;
    const defaultUser = this.activeUsers.find(
      (user) => user.id === loggedInUserId
    );
    const userForCopy = this.dataForCopy?.ownerId;
    const defaultUserForCopy = this.activeUsers.find(
      (user) => user.id === userForCopy
    );
    setTimeout(() => {
      this.isAdd && this.accountForm?.patchValue({ ownerId: defaultUser });
      this.isCopyAccount &&
        this.accountForm?.patchValue({ ownerId: defaultUserForCopy });
    });
  }

  /* Salutations: load data and populate default value */
  loadSalutations(): void {
    this.sharedDataService
      .loadSalutations()
      .pipe(
        map((salutations) => {
          this.salutations = this.formatDropDownData(salutations);
          this.defaultSalutation = this.getDefaultData(salutations);

          setTimeout(() => {
            this.isAdd && this.populateDefaultSalutation();
            this.isCopyAccount && this.populateCopySalutation();
          });
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  populateDefaultSalutation(): void {
    if (this.checkedFields.Title) {
      this.accountForm?.patchValue({
        contactSalutationId: this.defaultSalutation,
      });
    }
  }

  populateCopySalutation(): void {
    if (this.checkedFields.Title) {
      if (this.dataForCopy.accountContacts?.[0]?.contact?.salutationId) {
        const selectedSalutation = this.salutations.find(
          (s) =>
            s.id ===
            this.selectedAccount.accountContacts?.[0]?.contact?.salutationId
        );
        this.accountForm?.patchValue({
          contactSalutationId: selectedSalutation,
        });
      }
    }
  }

  /* Job functions: load data and populate default value */
  loadJobFunctions(): void {
    this.sharedDataService
      .loadJobFunctions()
      .pipe(
        map((jobFunctions) => {
          this.jobFunctions = this.formatDropDownDataJobFunction(jobFunctions);
          this.defaultJobFunction =  this.jobFunctions.find(j=> j?.isDefault);
          setTimeout(() => {
            this.isAdd && this.populateDefaultJobFunctions();
            this.isCopyAccount && this.populateCopyJobFunctions();
          });
        }),
        catchError(() => (this.jobFunctions = []))
      )
      .subscribe();
  }

  populateDefaultJobFunctions(): void {
    if (this.checkedFields.ContactDesignation) {
      this.accountForm?.patchValue({
        contactRoleId: this.defaultJobFunction?.id||null,
      });
    }
  }

  populateCopyJobFunctions(): void {
    if (this.checkedFields.ContactDesignation) {
      if (
        this.dataForCopy.accountContacts?.[0]?.contact?.contactRoles.length > 0
      ) {
        const contactRolesForCopy = [];
        this.dataForCopy.accountContacts?.[0]?.contact?.contactRoles.map(
          (contactRole) => {
            const jobFunction = this.jobFunctions.find(
              (f) => f.id == contactRole.roleId
            );
            if (jobFunction) {
              contactRolesForCopy.push(jobFunction);
            }
          }
        );
        this.accountForm?.patchValue({
            contactRoleId: contactRolesForCopy,
        });
      }
    }
  }

  /* Account Types: load data and populate default values */
  loadAccountTypes(): void {
    this.accountDataService
      .loadAccountTypes()
      .pipe(
        map((accountTypes) => {
          this.accountTypes = this.formatDropDownData(accountTypes);
          this.defaultAccountTypes = this.getDefaultData(accountTypes, true);

          setTimeout(() => {
            this.isAdd && this.populateDefaultAccountTypes();
            this.isCopyAccount && this.populateAccountTypesForCopy();
          });
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  populateDefaultAccountTypes(): void {
    if (this.checkedFields.AccountType) {
      this.accountForm?.patchValue({
        accountTypeIds: this.defaultAccountTypes,
      });
    }
  }

  populateAccountTypesForCopy(): void {
    const accountTypesForCopy = [];
    this.dataForCopy?.accountTypes.map((accountType) => {
      accountTypesForCopy.push({
        id: accountType?.type.id,
        name: accountType?.type.name,
      });
    });
    this.accountForm?.patchValue({ accountTypeIds: accountTypesForCopy });
  }

  /* Account Sources: load data and populate default value */
  loadAccountSources(): void {
    this.sharedDataService
      .loadSources()
      .pipe(
        map((accountSources) => {
          this.accountSources = this.formatDropDownData(accountSources);
          this.defaultAccountSource = this.getDefaultData(accountSources);

          setTimeout(() => {
            this.isAdd && this.populateDefaultAccountSource();
            this.isCopyAccount && this.populateAccountSourceForCopy();
          });
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  populateDefaultAccountSource(): void {
    if (this.checkedFields.AccountSource) {
      this.accountForm?.patchValue({
        accountSourceId: this.defaultAccountSource,
      });
    }
  }

  populateAccountSourceForCopy(): void {
    if (this.checkedFields.AccountSource) {
      if (this.dataForCopy.source?.id) {
        const accountSourceForCopy = this.accountSources.find(
          (s) => s.id === this.dataForCopy.source.id
        );
        this.accountForm?.patchValue({ accountSourceId: accountSourceForCopy });
      }
    }
  }

  /* Number of employees: load data and populate default value */
  loadEmployeeCount(): void {
    this.accountDataService
      .loadEmployeeCounts()
      .pipe(
        map((employeeCount) => {
          this.employeeCount = this.formatDropDownData(employeeCount);
          this.defaultEmployeeCount = this.getDefaultData(employeeCount);

          setTimeout(() => {
            this.isAdd && this.populateDefaultEmployeeCount();
            this.isCopyAccount && this.populateEmployeeCount();
          });
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  populateDefaultEmployeeCount(): void {
    if (this.checkedFields.NumberofEmployees) {
      this.accountForm?.patchValue({
        numberOfEmployeesId: this.defaultEmployeeCount,
      });
    }
  }

  populateEmployeeCount(): void {
    if (this.checkedFields.NumberofEmployees) {
      if (this.dataForCopy.employeesRange?.id) {
        const employeeCountForCopy = this.employeeCount.find(
          (s) => s.id === this.dataForCopy.employeesRange.id
        );
        this.accountForm?.patchValue({
          numberOfEmployeesId: employeeCountForCopy,
        });
      }
    }
  }

  /* Timezone: load data */
  loadTimezones(): void {
    this.accountDataService
      .loadTimezones()
      .pipe(
        map((timezones) => {
          this.timezones = timezones || [];
          this.timezones = this.timezones.map((el) => {
            return {
              id: el.id,
              name: el.name,
            };
          });
          this.isCopyAccount && this.populateTimeZoneForCopy();
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  populateTimeZoneForCopy(): void {
    if (this.checkedFields.Timezone) {
      if (this.dataForCopy?.timeZone?.id) {
        const timeZoneForCopy = this.timezones.find(
          (s) => s.id === this.dataForCopy.timeZone.id
        );
        this.accountForm?.patchValue({ timezoneId: timeZoneForCopy });
      }
    }
  }

  /* Currency: load data and populate default value */
  loadCurrencies(): void {
    this.importService.getOrgCurrency().subscribe(value=>{
      if(value){
        this.currencies = value;
        const activeCurrencies = this.currencies.filter(currency => currency?.statusId === 1);
          this.currencies = activeCurrencies.map((el) => {
            return {
              id: el.currencyId,
              name: el.code + ' - ' + el.country?.name,
            };

          });
          const defaultCurrency = activeCurrencies.find(currency => currency?.isBaseCurrency);
          if(defaultCurrency){
            this.defaultCurrency = {
              id: defaultCurrency.currencyId,
              name: defaultCurrency.code + ' - ' + defaultCurrency.country?.name,
            };
          }
          setTimeout(() => {
            this.isAdd && this.populateDefaultCurrency();
            this.isCopyAccount && this.populateCurrencyForCopy();
          });

      }
    })
  }

  populateDefaultCurrency(): void {
    if (this.checkedFields.Currency) {
      this.accountForm?.patchValue({ currencyId: this.defaultCurrency });
    }
  }

  populateCurrencyForCopy(): void {
    if (this.checkedFields.Currency) {
      if (this.dataForCopy.currencyUnit) {
        const currencyForCopy = this.currencies.find(
          (s) => s.id === this.dataForCopy.currencyUnit.id
        );
        this.accountForm?.patchValue({ currencyId: currencyForCopy });
      }
    }
  }

  /* Rating: load data and populate default value */
  loadRatings(): void {
    this.accountDataService
      .loadRatings()
      .pipe(
        map((ratings) => {
          if (ratings) {
            this.ratings = this.formatDropDownData(ratings);
            this.defaultRating = this.getDefaultData(ratings);

            setTimeout(() => {
              this.isAdd && this.populateDefaultRating();
              this.isCopyAccount && this.populateRatingForCopy();
            });
          }
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  populateDefaultRating(): void {
    if (this.checkedFields.Rating) {
      this.accountForm?.patchValue({ ratingId: this.defaultRating });
    }
  }

  populateRatingForCopy(): void {
    if (this.checkedFields.Rating) {
      if (this.dataForCopy.rating?.id) {
        const ratingIdForCopy = this.ratings.find(
          (s) => s.id === this.dataForCopy.rating.id
        );
        this.accountForm?.patchValue({ ratingId: ratingIdForCopy });
      }
    }
  }

  /* Annual Revenue: load data and populate default value */
  loadAnnualRevenues(): void {
    this.accountDataService
      .loadAnnualRevenues()
      .pipe(
        map((revenues) => {
          this.revenues = this.formatDropDownData(revenues);
          this.defaultRevenue = this.getDefaultData(revenues);

          setTimeout(() => {
            this.isAdd && this.populateDefaultAnnualRevenue();
            this.isCopyAccount && this.populateAnnulaRevenueForCopy();
          });
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  populateDefaultAnnualRevenue(): void {
    if (this.checkedFields.EstimatedAnnualRevenue) {
      this.accountForm?.patchValue({ annualRevenueId: this.defaultRevenue });
    }
  }

  populateAnnulaRevenueForCopy(): void {
    if (this.checkedFields.EstimatedAnnualRevenue) {
      if (this.dataForCopy.annualRevenue?.id) {
        const annualRevenueIdForCopy = this.revenues.find(
          (s) => s.id === this.dataForCopy.annualRevenue?.id
        );
        this.accountForm?.patchValue({
          annualRevenueId: annualRevenueIdForCopy,
        });
      }
    }
  }

  /* Ownership: load data and populate default value */
  loadOwnerships(): void {
    this.accountDataService
      .loadOwnerships()
      .pipe(
        map((ownerships) => {
          this.ownerships = this.formatDropDownData(ownerships);
          this.defaultOwnership = this.getDefaultData(ownerships);

          setTimeout(() => {
            this.isAdd && this.populateDefaultOwnership();
            this.isCopyAccount && this.populateOwnershipForCopy();
          });
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  populateDefaultOwnership(): void {
    if (this.checkedFields.OwnershipType) {
      this.accountForm?.patchValue({ ownershipTypeId: this.defaultOwnership });
    }
  }

  populateOwnershipForCopy() {
    if (this.checkedFields.OwnershipType) {
      if (this.dataForCopy.ownership?.id) {
        const ownershipIdForCopy = this.ownerships.find(
          (s) => s.id === this.dataForCopy.ownership?.id
        );
        this.accountForm?.patchValue({ ownershipTypeId: ownershipIdForCopy });
      }
    }
  }

  /* Industry: load data and populate default value */
  loadIndustries(): void {
    this.accountDataService
      .loadIndustries()
      .pipe(
        map((industries) => {
          this.industries = this.formatDropDownData(industries);
          this.defaultIndustry = this.getDefaultData(industries);

          setTimeout(() => {
            this.isAdd && this.populateDefaultIndustry();
            this.isCopyAccount && this.populateIndustryForCopy();
          });
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  populateDefaultIndustry(): void {
    if (this.checkedFields.Industry) {
      this.accountForm?.patchValue({ industryId: this.defaultIndustry });
    }
  }

  populateIndustryForCopy(): void {
    if (this.checkedFields?.Industry) {
      if (this.dataForCopy.industry?.id) {
        const industryIdForCopy = this.industries.find(
          (s) => s.id === this.dataForCopy.industry?.id
        );
        this.accountForm?.patchValue({ industryId: industryIdForCopy });
      }
    }
  }

  /* Country: load data */
  loadCountries(): void {
    this.sharedDataService
      .loadCountries()
      .pipe(
        map((countries) => {
          this.countries = countries || [];
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  /* Language: load data */
  loadLanguages(): void {
    this.sharedDataService
      .loadLanguages()
      .pipe(
        map((languages) => {
          this.languages = languages || [];
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  /* Address types: load data */
  loadAddressTypes(): void {
    this.sharedDataService
      .loadAddressTypes()
      .pipe(
        map((addressTypes) => {
          this.addressTypes = addressTypes?.filter((el) => el.isActive) || [];
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  /* Address classes: load data */
  loadAddressClasses(): void {
    this.sharedDataService
      .loadAddressClasses()
      .pipe(
        map((addressClasses) => {
          this.addressClasses =
            addressClasses?.filter((el) => el.isActive) || [];
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  /* Business Classification: populate default value */
  populateDefaultBusinessClassification(): void {
    setTimeout(() => {
      this.isAdd && this.accountForm?.patchValue({ stageId: (this.selectedStage?.id ? this.selectedStage : null) });
      this.isCopyAccount &&
        this.accountForm?.patchValue({
          stageId: this.businessClassificationForCopy,
        });
    });
  }

  // Search Parent Accounts
  searchParentAccounts(event) {
    let data = {
      currentPage: 0,
      pageSize: 0,
      organizationId: this.app.user.organizationId,
      loginUserId: this.app.user.userId,
      search: event.query,
      channelId: this.isCopyAccount
        ? this.currentSelectedAccountChannelIdForCopy
        : this.selectedChannel.id,
    };

    this.accountsHttpService.getAllAccounts(data).then((accounts) => {
      const activeAccounts = accounts?.filter(
        (obj) =>
          obj.statusId == 1 &&
          obj.businessName.length
      );
      this.parentAccounts = activeAccounts || [];

      if (!this.parentAccounts.length) {
        this.parentAccounts.push({ name: 'No Accounts found.' });
      }
    });
  }

    openParentAcountDialog() {
        this.chooseAccountCol();
        this.selectedRecordList = this.selectedParentAccount ? ParseHelper.DeepCopy([this.selectedParentAccount]) : [];
        this.displayManualPopup = true;
    }


    // below commented code will be there for next release

    removeParentAccount() {
        this.selectedParentAccount = null;
        // this.isChildTemplate=false;
        // this.getTemplateFormFields(this.selectedChannel.id)
    }

    saveParentAccount($event) {
        this.selectedRecordList = ParseHelper.DeepCopy($event.selectedReccords);
        if (this.selectedRecordList?.length > 0) {
            this.selectedParentAccount = ParseHelper.DeepCopy(this.selectedRecordList[0]);
            this.changeParrentAccount();
        }
        // this.isChildTemplate=true
        // this.getTemplateFormFields(this.selectedChannel.id)
        this.displayManualPopup = false;
    }

    chooseAccountCol() {
        this.columnSettingsService.getColumnSettings(this.selectedModule.id, this.selectedChannel.id).subscribe(
            resp => {
                let defaultColumnSettings: Partial<ColumnSettingsN> = ParseHelper.DeepCopy(resp);
                this.manualRuleColumnSetttings = defaultColumnSettings;
            },
            err => {
            }
        );
    }

    columnSettingSaved($event) {
        this.manualRuleColumnSetttings = $event;
    }

    manualpopupCancelClicked() {
        this.displayManualPopup = false;
    }

    changeParrentAccount(){
        if(this.selectedParentAccount?.id){
            this.generateChildSequenceNumber(this.selectedParentAccount?.id);
        }else{
            this.generateSequenceNumber();
        }
    }

  // Scroll to error handler function
  scrollToError(): void {
    const firstElementWithError = document.querySelector(
      '.ng-invalid[formControlName]'
    );
    this.scrollTo(firstElementWithError);

    if (!firstElementWithError) {
      const secondElementWithError = document.querySelector('.p-invalid');
      this.scrollTo(secondElementWithError);
    }
  }

  // Scroll to error element
  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  uploadProfilePic(files: File[]) {
    this.appMainService.isShowSpinner('upload');

    if (typeof Worker !== undefined) {
      for (let file of files) {
        let errors = validateFiles(file, 2, this.allowedExtensions);

        if (errors.length > 0) {
          for (let error of errors) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error.fileName + ': ' + error.error,
            });
          }

          this.appMainService.isHideSpinner('upload');
        } else {
          uploadFiles(file, ({ name, content, size }) => {
            const dataToUpload = {
              name,
              content,
              size,
            };

            const foundFile = this.selectedProfileImages.find(
              (el) => el.name === file.name
            );

            if (!foundFile) {
              this.selectedProfileImages.push(file);
              this.shownProfileImages.push(dataToUpload);
            }

            this.appMainService.isHideSpinner('upload');
          });
        }
      }
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail:
          'Please update the browser. Web Workers are not supported in the older versions of this browser.',
      });
    }
  }

  downloadFile(name, content): void {
    this.fileService.downloadFile(name, content);
  }

  removeProfileImg(index) {
    this.selectedProfileImages.splice(index, 1);
    this.shownProfileImages.splice(index, 1);
  }

  updateContactEmailPayload({ target: { value } }, index): void {
    this.contactEmails[index].emailAddress = value;
  }

  updateContactPhonePayload({ target: { value } }, index): void {
    this.contactPhones[index].phoneNumber = value;
  }

  updateContactPhoneCodePayload({ value }, index): void {
    const selectedCountry = this.countryData.find(item => item.CountryName === value);
    this.contactPhones[index].country = value||null;
    this.contactPhones[index].code = selectedCountry?.PhoneCode||null;
    // this.accountForm.get(this.contactPhones[index].formControlName).patchValue(null);
  }

  updateContactSocialPayload({ target: { value } }, index): void {
    this.contactSocialProfiles[index].socialProfileAddress = value;
  }

  checkFormValidation(form: FormGroup, tabIndex?): boolean {
    if (form.invalid) {
      const invalidFields = [];
      const controls = form.controls;

      for (const name in controls) {
        if (controls[name].invalid) {
          invalidFields.push(name);
        }
      }

      const invalidField = document.querySelector('.p-invalid');
      const classList = invalidField?.classList
        ? Array.from(invalidField.classList)
        : [];

      if (this.accountInfoCustomForm.invalid) {
        this.tabIndex = 0;
      } else if (
        this.accountDetailsCustomForm.invalid ||
        classList.includes('details-error')
      ) {
        this.tabIndex = 1;
      }

      this.isChildFormTouched = true;

      setTimeout(() => {
        this.scrollToError();
      }, 200);

      return false;
    }

    return true;
  }

  checkAccountNameValue(): void {
    let accountNameValue: string = this.accountForm.get('accountName').value;
    accountNameValue = accountNameValue?.trim() || '';

    if (!accountNameValue.length) {
      const contactFirstNameValue: string =
        this.accountForm.get('contactFirstName').value?.trim() || '';
      const contactLastNameValue: string =
        this.accountForm.get('contactLastName').value?.trim() || '';

      const accountName =
        `${contactFirstNameValue} ${contactLastNameValue}`.trim();

      this.accountForm.patchValue({ accountName });
    }
  }

  formatEmailDataForCopy() {
    const allContactEmails =
      this.dataForCopy.accountContacts?.[0]?.contact?.contactEmails;
    for (const emails of allContactEmails) {
      this.contactEmails.map((contactEmails) => {
        if (contactEmails.emailTypeId === emails.email?.emailTypeId) {
          contactEmails.emailAddress = emails.email?.emailAddress;
        }
      });
    }

    const allSocialProfile =
      this.dataForCopy.accountContacts?.[0]?.contact?.contactSocialProfiles;

    for (const socialProfile of allSocialProfile) {
      this.contactSocialProfiles.map((contactSocialProfiles) => {
        if (
          contactSocialProfiles.socialProfileTypeId ===
          socialProfile.socialProfile?.socialProfileTypeId
        ) {
          contactSocialProfiles.socialProfileAddress =
            socialProfile.socialProfile?.name;
        }
      });
    }
  }

  verifySubmit(type: 'save' | 'view') {
    this.isSubmitted = true;
    this.accountForm.markAllAsTouched();
    this.accountForm.markAsDirty();
    this.accountInfoCustomForm.markAllAsTouched();
    this.accountInfoCustomForm.markAsDirty();
    this.accountDetailsCustomForm.markAllAsTouched();
    this.accountDetailsCustomForm.markAsDirty();

    /** Custom section form */
    this.customSectionsForm?.forEach(formGroup => {
      if(formGroup){
        formGroup.markAllAsTouched();
        formGroup.markAsDirty();
      }
    });

    setTimeout(() => {
      this.onAddAccount(type);
    }, 200);
  }

  onAddAccount(type: 'save' | 'view') {

    // Check Account form validation
    let isValid = this.checkFormValidation(this.accountForm, 0);
    if (!isValid) {
      return;
    }

    const invalidField = document.querySelector('.p-invalid');
    const classList = invalidField?.classList ? Array.from(invalidField.classList) : [];
    const customFieldsError = classList.find(element => element.startsWith('custom-fields-error'));

    if (this.accountInfoCustomForm.invalid) {
        this.tabIndex = 0;
    } else if (this.accountDetailsCustomForm.invalid || classList.includes('details-error')) {
        this.tabIndex = 1;
    } else if (customFieldsError) {
        const tabIndex = parseInt(customFieldsError.split('custom-fields-error-')?.[1]||'0');
        this.tabIndex = tabIndex;
    }

    if (invalidField) {
      setTimeout(() => {
        this.scrollTo(invalidField);
      }, 200);
      return;
    }

    const processedFormValues = this.accountHelper.processFormValues(
      this.accountForm.getRawValue()
    );

    const addresses: Address[] = this.accountHelper.processAddressPayloadOnAdd(
      this.addressList
    );
    const customAttributeValues: CustomAttributeValue[] = this.customAttributeValues.filter(customValue=> {
        const values = customValue.values.filter(v=> v!==null);
        return values?.length || customValue?.attachments?.length;
    });
    processedFormValues.sequenceNumber =
      this.generateSequenceSeriesNumber ===
      processedFormValues.sequenceNumber.replace(/\s/g, '')
        ? ''
        : processedFormValues.sequenceNumber.replace(/\s/g, '');

    if (!processedFormValues.accountName) {
      processedFormValues.accountName = processedFormValues.contactFirstName;

      if (processedFormValues.contactLastName) {
        processedFormValues.accountName += ` ${processedFormValues.contactLastName}`;
      }
    }

    if (this.selectedParentAccount) {
      processedFormValues.parentAccountId = this.selectedParentAccount.id;
    }

    this.contactPhones.map(phone=>{
        const phoneNumber = this.accountForm.value[phone.formControlName]||"";
        phone.phoneNumber = phoneNumber.trim() ? `${phone?.code||''}${this.phoneNumberFormatService.removeMaskingFromNumber(phoneNumber)}` : "";
    })

    const formValues: AccountAdd = {
      ...processedFormValues,
      contactEmails: this.contactEmails.filter((el) => el.emailAddress.length),
      contactPhones: this.contactPhones.filter((el) => el.phoneNumber.length),
      contactSocialProfiles: this.contactSocialProfiles.filter(
        (el) => el.socialProfileAddress.length
      ),
      contactProfileImages: this.selectedProfileImages,
      addresses,
      customAttributeValues,
    };
    if (this.tags.length > 0) {
      formValues.tags = this.tags;
    }
    const formData: FormData = this.accountHelper.processFormData(formValues);
    this.formSubmitted = true;
    this.appMainService.isShowSpinner('createAccount');
    this.accountService
      .createNewAccount(formData)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response) => {
          if (this.isCopyAccount) {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Account Copied successfully...',
            });
          } else {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'New Account created successfully...',
            });
          }
          this.completeAccountAdd.emit({
            accountDetails: response,
            type: type,
          });
          this.appMainService.isHideSpinner('createAccount');
          this.formSubmitted = false;
          this.isSubmitted = true;
        },
        error: (err) => {
          const detail: string =
            typeof err.error.Message === 'string'
              ? err.error.Message
              : 'Error to add new account...';
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail,
          });
          this.appMainService.isHideSpinner('createAccount');
          this.formSubmitted = false;
          this.isSubmitted = true;
        },
        complete: () => {
          this.appMainService.isHideSpinner('createAccount');
        },
      });
  }

  // Event to update the address list on Address Details section
  onUpdateAddressList($event) {
    this.addressList = $event.addressList;
    this.addressList.sort(this.compare);
  }

  compare(a, b) {
    if (a.address.name < b.address.name) {
      return -1;
    }

    if (a.address.name > b.address.name) {
      return 1;
    }

    return 0;
  }

  // Close the modal
  onCloseAddEditView(): void {
    if (this.isAdd && this.isEdit) {
        this.app.getAllObjects();
    }

    this.closeModal.emit();
    this.accountForm?.reset();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  //tags
  removeTag(i) {
    this.tags.splice(i, 1);
  }

  addTag() {
    this.displayAddTag = true;
    if (this.tags?.length > 0) {
      this.tags = JSON.parse(JSON.stringify(this.removeDuplicates(this.tags)));
      this.selectedValues = this.tags;
    }
  }

  removeDuplicates(arr: Tag[]): Tag[] {
    const uniqueSet = new Set();

    return arr.filter((obj) => {
      const objString = JSON.stringify(obj);
      if (!uniqueSet.has(objString)) {
        uniqueSet.add(objString);
        return true;
      }
      return false;
    });
  }

  saveTag(tags: Tag[]) {
    if (tags.length > 0) {
      this.tags = JSON.parse(
        JSON.stringify(this.removeDuplicates(this.selectedValues))
      );
    }
  }

  loadTages() {
    this.accountService
      .getAllTags()
      .pipe(
        tap((tags) => {
          const filteredTags = tags.filter((data) => data?.statusId == 1);
          this.tagList = JSON.parse(JSON.stringify(filteredTags));
        }),
        catchError(() => of([])),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe();
  }

  createTag(tag: Tag): void {
    this.accountService
      .addTags(tag)
      .pipe(
        tap((tag: Tag) => {
          if (tag !== null) {
            this.loadTages();
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Added Successfully...',
            });
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Duplicate tag names are not allowed.',
            });
          }
          this.displayCreateTag = false;
        }),
        catchError(() => of(null)),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe();
  }

  openCreateTagDialog() {
    this.displayCreateTag = true;
  }

  assignSelectedTags(tags: Tag[]) {
    if (tags.length > 0) {
      this.tags = JSON.parse(JSON.stringify(this.removeDuplicates(tags)));
    }
    this.displayAddTag = false;
  }

  //communication
  changeSubscrib(e,s){
    if(s.isSubscrib){
      s.unSubscrib = false;
    } else {
      s.unSubscrib = true;
    }
  }

   // ------------stage owner work
    getSettingsData() {
        this.crmSettingsService.getCrmSettingFieldsList().subscribe({
            next: (response: CrmSettingModel[]) => {
                this.accountOwnerSettings = response?.find(data => data?.moduleId == AccountModuleId && data?.code == "StageOwnerSetting");
                if (this.accountOwnerSettings?.enabled) {
                    this.selectedOwnerStageDefault = this.stages?.find(data => data?.name == this.selectedStage?.name && data?.id == this.selectedStage?.id);
                    this.accountForm.patchValue({ stageOwnerId: this.selectedOwnerStageDefault?.ownerId });
                }
            },
            error: (error) => { }
        });
    }

    setStageOwnerAccordingToStage(value) {
        if (value) {
            let stageOwnerId;
            this.selectedOwnerStage = this.stages?.find(data => data?.id == value);
            stageOwnerId = this.selectedOwnerStage?.ownerId || null;
            this.accountForm.patchValue({ stageOwnerId: this.selectedOwnerStage?.ownerId });
        }
    }

    getCountryCode(data?) {
        this.accountUserService.countryCode().pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                {
                    next: (response) => {
                        this.countryData = response;
                    },
                    error: (error) => {
                        this.appMainService.isHideSpinner('authenSetUp');
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error?.error?.message ? error?.error?.message : 'please try again...'
                        });

                    },
                    complete: () => { },
                });
    }

    async getPhoneNumberTemplate() {
        this.phoneNumberFormat = await this.phoneNumberFormatService.getPhoneNumberFormat();
    }

    onSelectAccountPhoneCountry(event: any){
        const selectedCountry = this.countryData.find(item => item.CountryName === event.value);
        if(selectedCountry){
            this.accountForm.patchValue({
                accountPhoneCode: selectedCountry.PhoneCode
            })
        }
    }

    //for ContactRoles
      
  loadContactRoles(): void {
    this.appMainService.isShowSpinner('contactRoles');
    this.configurationService.getNewAllContactRoles().subscribe({
      next: (resp: any[]) => {
        this.contactRoles = resp?.length ? resp : [];
        this.defaultContactRoles =  this.contactRoles.filter(j=> j?.isDefault);
        this.appMainService.isHideSpinner('contactRoles');
        setTimeout(() => {
          this.isAdd && this.populateDefaultContactRoles();
          this.isCopyAccount && this.populateCopyContactRoles();
        });
      },
      error: (err) => {
        this.appMainService.isHideSpinner('contactRoles');
      }
    });
  }

  populateDefaultContactRoles(): void { 
    if (this.checkedFields.ContactRoles) {
      this.accountForm?.patchValue({
        contactJobFunctionIds: this.defaultContactRoles,
      });
    }
  }

  populateCopyContactRoles(): void {
    if (this.checkedFields.ContactRoles) {
      if (
        this.dataForCopy.accountContacts?.[0]?.contact?.contactRoles.length > 0
      ) {
        const contactRolesForCopy = [];
        this.dataForCopy.accountContacts?.[0]?.contact?.contactRoles.map(
          (contactRole) => {
            const jobFunction = this.contactRoles.find(
              (f) => f.id == contactRole.roleId
            );
            if (jobFunction) {
              contactRolesForCopy.push(jobFunction);
            }
          }
        );
        this.accountForm?.patchValue({
          contactJobFunctionIds: contactRolesForCopy,
        });
      }
    }
}
}

